import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";

import { useLanguage } from "../../context/LanguageContext";

import dataEn from "../../languages/en/createNewPass.json";
import dataTh from "../../languages/th/createNewPass.json";

const CreateNewPass = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  const data = selectedLanguage === "en" ? dataEn : dataTh;

  const location = useLocation();
  const [confirmationCode, setConfirmationCode] = useState(Array(6).fill(""));
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isConfirmationCodeValid, setConfirmationCodeValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [isConfirmPasswordValid, setConfirmPasswordValid] = useState(true);

  const handleInputChange = (index, value) => {
    // Limit the input to only one character
    if (value.length <= 1) {
      const newConfirmationCode = [...confirmationCode];
      newConfirmationCode[index] = value;
      setConfirmationCode(newConfirmationCode);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate confirmation code
    const isConfirmationCodeValid = confirmationCode.every(
      (code) => code.trim() !== ""
    );

    // Validate password
    const isPasswordValid =
      password.length >= 8 &&
      /\d/.test(password) &&
      /[a-zA-Z]/.test(password) &&
      /[!@#$%^&*()_+[\]{};':"\\|,.<>?]/.test(password);

    // Validate confirm password
    const isConfirmPasswordValid = password === confirmPassword;

    // Update the state variables for validation
    setConfirmationCodeValid(isConfirmationCodeValid);
    setPasswordValid(isPasswordValid);
    setConfirmPasswordValid(isConfirmPasswordValid);

    // Check if all fields are valid before submitting the form
    if (isConfirmationCodeValid && isPasswordValid && isConfirmPasswordValid) {
      console.log("Form submitted successfully!");
      // Handle form submission here
    }
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="max-w-md mx-auto mt-8 p-4 bg-white rounded-lg">
        <h2 className="text-2xl font-bold mb-4">{data.title}</h2>
        <p className="mb-4 text-xs text-gray-500">{data.subTitle}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex-col">
            <label
              htmlFor="confirmationCode"
              className="block text-sm font-medium text-gray-700"
            >
              {data.confirmCode}
              <span className="text-red-500">*</span>
            </label>
            <div className="flex">
              {Array.from({ length: 6 }, (_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={confirmationCode[index]}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  className={`flex-grow border p-2 mx-1 w-16 text-center border-gray-400 rounded-xl 
                  ${confirmationCode[index].trim() === "" && "border-red-500"}`}
                />
              ))}
            </div>
            {!isConfirmationCodeValid && (
              <p className="mt-2 text-sm text-red-500">
                {confirmationCode.every((code) => code.trim() === "")
                  ? data.validConfirmCode[0]
                  : data.validConfirmCode[1]}
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              {data.password} <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              //   required
              className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg p-2 pl-6 border 
              ${isPasswordValid ? "border-gray-400" : "border-red-500"}`}
            />
            {!isPasswordValid &&
              (password.length === 0 ? (
                <p className="mt-2 text-sm text-red-500">
                  {data.validPassword[0]}
                </p>
              ) : (
                <p className="mt-2 text-sm">
                  <span className=" text-red-500 font-semibold">
                    {data.validPassword[1]}
                  </span>{" "}
                  <br />
                  {data.validPassword[2]} <br /> {data.validPassword[3]}
                  <span className="text-primary-900">
                    {" "}
                    {data.validPassword[4]}{" "}
                  </span>{" "}
                  {data.validPassword[5]} <br />
                  {data.validPassword[6]}
                  <div className="mb-4 mt-1 flex space-x-2">
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                  </div>
                  <span className=""> {data.validPassword[7]} </span>
                </p>
              ))}
          </div>
          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-700"
            >
              {data.confirmPassword} <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              //   required
              className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg p-2 pl-6 border 
              ${isConfirmPasswordValid ? "border-gray-400" : "border-red-500"}`}
            />
            {!isConfirmPasswordValid &&
              (isPasswordValid || confirmPassword.length === 0 ? (
                <>
                  {confirmPassword.length > 0 ? (
                    <p className="mt-2 text-sm text-red-500">
                      {data.validConfirmPassword[0]}
                    </p>
                  ) : (
                    ""
                  )}

                  {confirmPassword !== password &&
                  confirmPassword.length === 0 ? (
                    <p className="mt-2 text-sm text-red-500">
                      {data.validConfirmPassword[1]}
                    </p>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <p className="mt-2 text-sm">
                  <span className=" text-red-500 font-semibold">
                    {data.validConfirmPassword[2]}
                  </span>{" "}
                  <br />
                  {data.validConfirmPassword[3]} <br />{" "}
                  {data.validConfirmPassword[4]} <br />
                  <span className="text-primary-900">
                    {" "}
                    {data.validConfirmPassword[5]}{" "}
                  </span>{" "}
                  {data.validConfirmPassword[6]} <br />
                  {data.validConfirmPassword[7]}
                  <div className="mb-4 mt-1 flex space-x-2">
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                  </div>
                  <span className="">
                    {" "}
                    {data.validConfirmPassword[8]} <br />
                  </span>
                </p>
              ))}
          </div>
          <button
            type="submit"
            className={`flex items-center justify-center w-full bg-gradient-to-r from-primary-900 to-primary-600 text-white py-4 rounded-full font-bold hover:bg-blue-600`}
          >
            {data.submit}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateNewPass;
